import { useEffect } from 'react';

const EMBED_SCRIPT_SRC = 'https://letmeclean.bookingkoala.com/resources/embed.js';

export default function BookingEmbed() {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${EMBED_SCRIPT_SRC}"]`);
    if (existing) return;
    const script = document.createElement('script');
    script.src = EMBED_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="book" className="bg-background-100 scroll-mt-24">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">Get your price &amp; book</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            <span className="font-semibold text-foreground-900">$0 charged today</span> — you pay after the cleaning is done.{' '}
            <span className="text-accent-600 font-semibold">−10% on your first booking with code WELCOME10.</span>
          </p>
        </div>
        <div className="rounded-3xl bg-background-50 border border-background-200 p-3 md:p-5 shadow-pink-lg">
          <iframe
            src="https://letmeclean.bookingkoala.com/booknow/home_cleaning?embed=true&bar=false&banner=false"
            style={{ border: 'none', height: '1000px' }}
            width="100%"
            scrolling="no"
            title="Let Me Clean booking form"
            className="block w-full min-h-[1400px] md:min-h-[1000px] rounded-2xl"
          ></iframe>
        </div>
      </div>
    </section>
  );
}